import { CheckRes } from "../types/types"

// --------------------------------------------------------------------------------

export const hasErrors = (checkRes?: CheckRes) => {
    if (!checkRes) return false

    const err = Object.values(checkRes.result)[0].errors
    const errArr = Object.values(err)[0]
    if (errArr.length > 0)
        return true

    return false
}

export const getErrors = (checkRes?: CheckRes) => {
    if (!checkRes) return false

    const err = Object.values(checkRes.result)[0].errors
    const errArr = Object.values(err)[0]
    if (errArr.length > 0)
        return true

    return false
}